<template>
  <div>
    <van-nav-bar
      title="更换手机号"
      left-text=""
      left-arrow
      @click-left="$router.push('/member/information')"
    />
    <van-form @submit="setPhone" id="changePhone">
      <van-field
        v-model="userPhone"
        name="phone"
        label="当前手机号"
        placeholder="当前手机号"
        readonly
      />
      <van-field
        v-model="newPhone"
        name="newPhone"
        label="新手机号"
        placeholder="新手机号"
        :rules="[{ required: true, message: '请填写新手机号' }]"
      />
      <van-field
        v-model="sms"
        center
        clearable
        label="短信验证码"
        placeholder="请输入短信验证码"
        :rules="[{ required: true, message: '请填写验证码' }]"
      >
        <template #button>
          <van-button
            native-type="button"
            size="small"
            plain
            type="info"
            @click="getCode"
            :disabled="disabled"
            color="#D02E27"
            style="border: 0px; background-color: #fafafa"
            >{{ getCodeText }}</van-button
          >
        </template>
      </van-field>
      <div style="display: flex; justify-content: center">
        <van-button
          class="change_phn_btn"
          round
          block
          size="small"
          color="#D02E27"
          type="danger"
          native-type="submit"
          style="height: 50px"
        >
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import JSEncrypt from "jsencrypt/bin/jsencrypt";
export default {
  name: "BinkPhone",
  data() {
    return {
      sms: "",
      newPhone: "",
      getCodeText: "获取验证码",
      disabled: false,
      userPhone:"",

    };
  },
  computed: {
    phone: function () {
      return this.$store.state.phone;
    },
    user: function () {
      return this.$store.state.user;
    },
  },
  methods: {
    getUserPhone() {
       let that = this;
       that
         .$http({
           url: "/",
           method: "post",
           data: {
             nozzle: "user_info",
             token: sessionStorage.getItem("token")
           }
         })
         .then(function(res) {
           if (res.data.code == 1) {
             that.userPhone = res.data.data.phone;
           }
             else if (res.data.code == 0 || res.data.code == -1) {
             that.$message.error(res.data.msg);
           }
         });
     },
    isLogin() {
      let that = this;
      if (!that.$store.state.loginType) {
        that.$router.push("/login");
      }
    },
    setPhone() {
      let that = this;
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.newPhone)) {
        that.$toast.fail("手机号码格式不正确");
      } else if (that.sms == "") {
        that.$toast.fail("请输入验证码");
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.newPhone.toString();
        let inputPhone = that.encryptMessage(userPhone, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "modify_phone_e",
              token: sessionStorage.getItem("token"),
              phone: inputPhone,
              code: that.sms,
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.$toast.success({
                message: res.data.msg,
                onClose: function () {
                  that.$router.push("/member/information");
                },
              });
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(res.data.msg);
            }
          });
      }
    },
    //获取验证码
    getCode() {
      let that = this;
      clearInterval(window.timer1);
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.newPhone)) {
        that.$toast.fail("手机号格式不正确");
      } else {
        let publicKey = localStorage.getItem("encript_public_key");
        let userPhone = that.newPhone.toString();
        let inputPhone = that.encryptMessage(userPhone, publicKey);
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "modifyInfo_code_e",
              token: sessionStorage.getItem("token"),
              info: inputPhone,
              type: 2,
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.$toast.success({
                message: res.data.msg,
              });
              var time = 60;
              that.disabled = true;
              that.getCodeText = time + "s";
              window.timer1 = setInterval(function () {
                time--;
                that.getCodeText = time + "s";
                if (time <= 0) {
                  clearInterval(window.timer1);
                  that.disabled = false;
                  that.getCodeText = "获取验证码";
                }
              }, 1000);
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(res.data.msg);
            }
          });
      }
    },
    encryptMessage(message, publicKey) {
      const jsEncrypt = new JSEncrypt();
      jsEncrypt.setPublicKey(publicKey);
      return jsEncrypt.encrypt(message);
    },
  },
  mounted: function () {
    let that = this;
    that.isLogin();
    that.getUserPhone();
  },
};
</script>

<style scoped>
.change_phn_btn {
  position: fixed;
  bottom: 72px;
  width: 90%;
  margin: 20px;
  font-size: 15px;
}
</style>
<style>
#changePhone .van-field {
  background-color: #fafafa;
  margin: 20px;
  width: unset;
  border-radius: 10px;
}
#changePhone .van-field__label {
  color:#7b7777 !important;
}
#changePhone .van-field__control{
  color:#000000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/BinkPhone.vue